import { Box, styled } from '@mui/material'

export const ExamplePillsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(2, 4),
  gap: theme.spacing(1.25),

  overflow: 'auto',
  '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
    display: 'none',
  },
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingLeft: 0,
    paddingRight: 0,
  },
}))

export const ProjectInfoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}))

export const ProjectInfoFirstSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    width: '40%',
    justifyContent: 'center',
  },
  [theme.breakpoints.up('lg')]: {
    alignItems: 'flex-start',
    width: '35%',
  },
}))

export const ProjectStatsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(3),
  margin: theme.spacing(4, 0),
  [theme.breakpoints.up('md')]: {
    flexDirection: 'column',
    margin: theme.spacing(5, 0),
  },
}))

export const MainContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    marginBottom: 0,
    height: 'calc(100vh - 80px)',
    maxHeight: '700px',
  },
  [theme.breakpoints.up('lg')]: {
    maxHeight: '1000px',
  },
}))
